import { Injectable } from '@angular/core';
import CustomStore from 'devextreme/data/custom_store';
import DataSource from 'devextreme/data/data_source';
import { EntityQuery, iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig, iBisValidationService } from '@dohu/ibis-common';
import { EditGeographicAreaService } from '../../admin/geographic-area/edit-geographic-area.service';

@Injectable()

export class PatientDetailsService extends iBisSecureEditService {

    public data: CustomStore;
    private ft: boolean;
    public index = 0;
    public localities: DataSource;
    public counties: DataSource;


    public masc: string[] = ['1', '3', '5', '7'];
    public fem: string[] = ['2', '4', '6', '8'];
    public sex: { id: number; value: string }[];
    public patientOptionsList = [{ description: this.L('MINOR'), value: 'isMinor' }, { description: this.L('FOREIGNER'), value: 'isForeigner' },
    { description: this.L('MARKETING_AGREEMENT'), value: 'marketingAgreement' }, { description: this.L('SMS_AGREEMENT'), value: 'smsAgreement' },
    { description: this.L('GDPR_AGREEMENT'), value: 'gdprAgreement' }]

    constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService,
        public geo: EditGeographicAreaService, private vatValid: iBisValidationService) {
        super(auth, entity, config, lg);
        this.title = 'PATIENT';
        this.validation = 'patientValidation';
        this.ft = false;
    }

    protected load(): void {
        this.data = this.getData();
        this.localities = this.getLocality();
        this.counties = this.getCounty();
        this.sex = this.GetSexes();
    }

    public set filter(filter: boolean) {
        this.ft = filter;
        this.data = this.getData();
    }

    public get filter() {
        return this.ft;
    }

    public set countyId(id: string) {
        this.localities = this.getLocality(id);
    }

    getById(id: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.entity.getById('Patient', id).then((res: any) => {
                if (res) {
                    resolve(res);
                } else {
                    reject();
                }
            }, error => this.lg.showError(error));
        });
    }

    onRemove(id: string): Promise<void> {
        return this.entity.remove('Patient', id);
    }

    onSaveEv(): Promise<any> {
        this.model.firstName = this.model.firstName.trim();
        this.model.lastName = this.model.lastName.trim();
        return this.entity.save('Patient', this.model.id, this.model);
    }

    reset(): void {
        this.model = this.createDefault();
    }

    createDefault() {
        return { isActiv: true };
    }

    public checkCNP = (options: any) => {
        let m: any;
        if (options.value && options.value.length !== 0) {
            return this.vatValid.isCPNValid(options.value);
        }
        return true;
    }

    public getBirthday(pin: string): any[] {
        if (typeof pin == 'string' && this.vatValid.isCPNValid(pin)) {
            const yy = [1, 2].indexOf(parseInt(pin[0], 10)) > -1 ? '19' : '20';
            const bd = new Date(parseInt(yy + pin.substring(1, 3), 10), parseInt(pin.substring(3, 5), 10) - 1, parseInt(pin.substring(5, 7)));
            const age = Math.round((new Date().getTime() - bd.getTime()) / 1000 / 60 / 60 / 24 / 365)
            return [bd, age];
        }
        return []
    }

    protected getLocality(countyId: any = null): DataSource {
        return new DataSource({ store: this.geo.getGeographic(1, countyId), paginate: true, pageSize: 50 });
    }

    protected getCounty(zoneId: any = null): DataSource {
        return new DataSource({ store: this.geo.getGeographic(2, zoneId), paginate: true, pageSize: 15 });
    }

    public reloadData(): void {
        this.data = this.getData();
    }

    private getData(): CustomStore {
        const q = new EntityQuery('Patient').addOrderBy(['lastName']);
        if (this.ft) {
            const finishedApp = new EntityQuery('Appointment').eq('statusId', 5);
            const pwConsultations = new EntityQuery('Patient').addOrderBy(['firstName', 'lastName']);
            pwConsultations.link('id', 'patientId', finishedApp);
            pwConsultations.distinct = true;
            q.except(pwConsultations);
        }
        return this.entity.store(q, false, 'id');
    }

    private GetSexes(): { id: number; value: string }[] {
        return [{ id: 1, value: 'Masculin' }, { id: 2, value: 'Feminin' }];
    }
}
